module.exports = __webpack_public_path__ + "img/login.717cd7bd.png";